import React, { Component } from 'react';
import { Card, PageHeader, Table, Typography, Divider, Checkbox, Space, Tag } from 'antd';
import { withTranslation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import { getProjectTypeCropSummary } from '../util/APIUtils';
import { formatCurrency } from '../util/Helpers';
import './Finance.css';
import YearSelect from '../common/YearSelect';

const { Text } = Typography;

class ProjectTypeCropSummary extends Component {
    state = {
        year: null,
        isLoading: false,
        priorityChecked: true,
        fgChecked: true,
        payoutChecked: false,
        projectTypeCropSummary: []
    };

    loadBudgetOverviews = (val) => {
        this.setState({ isLoading: true });
        getProjectTypeCropSummary(val)
            .then(response => this.setState({ projectTypeCropSummary: response, isLoading: false }))
            .catch(() => this.setState({ isLoading: false }));
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            this.props.history.push("/login");
        }
    }

    handleYearInput = (val) => {
        this.setState({ year: val });
        this.loadBudgetOverviews(val);
    }

    onCheckboxChange = (type) => {
        this.setState((prevState) => ({ [type]: !prevState[type] }));
    }

    render() {
        const { priorityChecked, fgChecked, payoutChecked, projectTypeCropSummary, isLoading, year } = this.state;

        const groupedData = {};
        const projectGroups = {};

        projectTypeCropSummary.forEach(item => {
            if (!groupedData[item.projectType]) {
                groupedData[item.projectType] = {
                    ...item,
                    cropName: "Zwischensumme",
                    type: "subtotal_ptype",
                    key: `subtotal_${item.projectType}`
                };
                Object.keys(groupedData[item.projectType]).forEach(key => {
                    if (typeof groupedData[item.projectType][key] === "number") {
                        groupedData[item.projectType][key] = 0;
                    }
                });
            }

            Object.keys(item).forEach(key => {
                if (typeof item[key] === "number") {
                    groupedData[item.projectType][key] += item[key];
                }
            });

            if (!projectGroups[item.projectType]) {
                projectGroups[item.projectType] = [];
            }
            projectGroups[item.projectType].push(item);
        });

        let tableData = [];
        Object.keys(projectGroups).forEach(projectType => {
            tableData.push(...projectGroups[projectType]);
            tableData.push(groupedData[projectType]);
        });

        const allColumns = [
            { title: "Typ", dataIndex: 'projectType', key: 'projectType', align: "right" },
            { title: "Kulturart", dataIndex: 'cropName', key: 'cropName', align: "right" },
            priorityChecked && { title: "Gesamt Kalkulation", dataIndex: 'totalItemBudget', key: 'totalItemBudget', align: "right", render: v => formatCurrency(v) },
            priorityChecked && { title: "#", dataIndex: 'totalItemCount', key: 'totalItemCount', align: "right", render: v => <Tag color="gold">{v}</Tag> },
            priorityChecked && { title: "Tätigkeiten", dataIndex: 'totalAccountingBudget', key: 'totalAccountingBudget', align: "right", render: v => formatCurrency(v) },
            priorityChecked && { title: "Analysen", dataIndex: 'totalExamBudget', key: 'totalExamBudget', align: "right", render: v => formatCurrency(v) },
            fgChecked && { title: "FG OK", dataIndex: 'totalFgOkAmount', key: 'totalFgOkAmount', align: "right", render: v => formatCurrency(v) },
            fgChecked && { title: "#", dataIndex: 'totalFgOkCount', key: 'totalFgOkCount', align: "right", render: v => <Tag color="gold">{v}</Tag> },
            fgChecked && { title: "FG Zurückgestellt", dataIndex: 'totalFgOnHoldAmount', key: 'totalFgOnHoldAmount', align: "right", render: v => formatCurrency(v) },
            fgChecked && { title: "#", dataIndex: 'totalFgOnHoldCount', key: 'totalFgOnHoldCount', align: "right", render: v => <Tag color="gold">{v}</Tag> },
            fgChecked && { title: "FG Abgelehnt", dataIndex: 'totalFgRejectAmount', key: 'totalFgRejectAmount', align: "right", render: v => formatCurrency(v) },
            fgChecked && { title: "#", dataIndex: 'totalFgRejectCount', key: 'totalFgRejectCount', align: "right", render: v => <Tag color="gold">{v}</Tag> },
            payoutChecked && { title: "Auszahl OK", dataIndex: 'totalPayoutOkAmount', key: 'totalPayoutOkAmount', align: "right", render: v => formatCurrency(v) },
            payoutChecked && { title: "#", dataIndex: 'totalPayoutOkCount', key: 'totalPayoutOkCount', align: "right", render: v => <Tag color="gold">{v}</Tag> },
        ].filter(Boolean);

        const columns = allColumns.filter(col => !col.type || (col.type === "priority" && priorityChecked) || (col.type === "fg" && fgChecked) || (col.type === "payout" && payoutChecked));

        return (
            <Card bordered loading={isLoading}>
                <Space>
                    <YearSelect setItem={this.handleYearInput} selectedItem={year} />
                    <Checkbox checked={priorityChecked} onChange={() => this.onCheckboxChange('priorityChecked')}>Plan</Checkbox>
                    <Checkbox checked={fgChecked} onChange={() => this.onCheckboxChange('fgChecked')}>Betrag FG</Checkbox>
                    <Checkbox checked={payoutChecked} onChange={() => this.onCheckboxChange('payoutChecked')}>Auszahlbetrag</Checkbox>
                </Space>
                <Divider dashed />
                <Table size="small" dataSource={tableData} columns={allColumns} pagination={false} rowClassName={(rec) => rec.type === 'subtotal_ptype' && 'table-row-pt'} summary={() => (
                    <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={2} align='right'><Text strong>Gesamt</Text></Table.Summary.Cell>
                        {allColumns.slice(2).map(col => (
                            <Table.Summary.Cell key={col.key} align="right">
                                <Text strong>
                                    {col.dataIndex.toLowerCase().endsWith('count')
                                        ? <Tag color="gold">{projectTypeCropSummary.reduce((sum, row) => sum + (row[col.dataIndex] || 0), 0)}</Tag>
                                        : formatCurrency(projectTypeCropSummary.reduce((sum, row) => sum + (row[col.dataIndex] || 0), 0))
                                    }
                                </Text>
                            </Table.Summary.Cell>
                        ))}
                    </Table.Summary.Row>
                )} />

            </Card>
        );
    }
}

export default withTranslation()(withRouter(ProjectTypeCropSummary));